import React from 'react';
import PropTypes from 'prop-types';
import getLabel from '../../translations/messages';
import './InputPassword.css';

const InputPassword = (props, context) => (
  <div className="InputPassword" style={props.style}>
    <div className="input-label">{getLabel(context.locale, props.label)}</div>
    <input
      type="password"
      name={props.name}
      value={props.value}
      onChange={props.handleChange}
      onBlur={props.handleBlur}
      onFocus={props.handleFocus}
      placeholder={props.placeholder ? props.placeholder : ''}
      autoComplete="off"
    />
  </div>
);

InputPassword.contextTypes = {
  locale: PropTypes.string,
};

export default InputPassword;



// WEBPACK FOOTER //
// ./src/main/components/input/InputPassword.js